import React from 'react';
import { Provider } from 'react-redux';
import store from './store';
import MerchantContextProvider from './MerchantContextProvider';
import BillingConfirmationProvider from '../../features/account/billing/BillingConfirmationProvider';
import QueryProvider from './QueryProvider';

type AppProvidersProps = {
  children: React.ReactNode;
};

const AppProviders = ({ children }: AppProvidersProps) => (
  <Provider store={store}>
    <QueryProvider>
      <MerchantContextProvider>
        <BillingConfirmationProvider>{children}</BillingConfirmationProvider>
      </MerchantContextProvider>
    </QueryProvider>
  </Provider>
);

export default AppProviders;
